import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChipsComponent } from '../chips/chips.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@Component({
  selector: 'common-rate-advanced-selector-search',
  imports: [FormsModule, ChipsComponent, ScrollingModule],
  templateUrl: './rate-advanced-selector-search.component.html',
  styleUrls: ['./rate-advanced-selector-search.component.scss'],
})
export class RateAdvancedSelectorSearchComponent implements OnInit {
  @Input() options: any;
  @Input() placeholder: string;
  @Input() isPopUp: boolean = false;
  @Input() popUpTitle: string;
  @Input() showSelectAll: boolean = false;
  @Output() applyFilter = new EventEmitter();

  searchKey: string;
  filteredOptions: any[] = [];
  protected isAllSelected: boolean = false;

  constructor(private readonly modalService: NgbModal) {}

  ngOnInit() {
    this.filteredOptions = this.options;
  }

  protected toggleSelectAll(checked: boolean): void {
    if (!checked) {
      this.clearAll();
      this.isAllSelected = false;
      return;
    }

    this.filteredOptions?.forEach((group) => {
      group.selected = true;
      group.options?.forEach((option) => {
        option.selected = true;
        option.visible = true;
      });
    });

    this.isAllSelected = true;
  }

  private checkIfAllSelected(): void {
    if (!this.showSelectAll) {
      return;
    }
    this.isAllSelected = this.filteredOptions?.every(group => group.selected);
  }

  clearAll(): void {
    this.searchKey = '';
    this.filterOptions();
    this.filteredOptions?.forEach((group) => {
      group.selected = false;
      group.options?.forEach((option) => {
        option.selected = false;
        option.visible = true;
      });
    });
    this.isAllSelected = false;
  }

  toggleGroup(group): void {
    group.options?.forEach((option) => {
      option.selected = group.selected;
    });
    this.checkIfAllSelected();
  }

  updateSelectAll(group): void {
    const allSelected = group.options.every((option) => option.selected);

    group.selected = allSelected;
    this.checkIfAllSelected();
  }

  applyFilters(): void {
    this.applyFilter.emit();
    if (this.isPopUp) {
      this.modalService.dismissAll();
    }
  }

  closePopUp() {
    if (this.isPopUp) {
      this.modalService.dismissAll();
    }
  }

  removeOption(option: any) {
    const group = this.options?.find((grp: any) =>
      grp?.options?.some(
        (opt: any) => opt?.airportCode === option?.airportCode,
      ),
    );

    if (group) {
      option.selected = false;

      this.updateSelectAll(group);
    }

    this.checkIfAllSelected();
  }

  onChangeKey(value: string) {
    this.searchKey = value;
    this.filterOptions();
  }

  filterOptions() {
    if (!this.searchKey) {
      this.filteredOptions = this.options;
      return;
    }

    const lowerCaseSearchKey = this.searchKey.toLowerCase();

    this.filteredOptions = this.options
      ?.map((group) => {
        const filteredGroupOptions = group?.options?.filter((option) => {
          const labelMatches = option.label
              .toLowerCase()
              .includes(lowerCaseSearchKey),
            valueMatches = option?.value
              ?.toLowerCase()
              ?.includes(lowerCaseSearchKey),
            keywordMatches = option.keywords?.some((keyword) =>
              keyword.toLowerCase().includes(lowerCaseSearchKey),
            );
          return labelMatches || keywordMatches || valueMatches;
        });

        return {
          ...group,
          options: filteredGroupOptions,
        };
      })
      .filter((group) => group?.options?.length > 0);
  }

  trackByGroupId(index: number, group): string {
    return group.name;
  }

  get dropdownHeight(): number {
    return this.options?.length * 60;
  }
}
